<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <router-link
            class="btn btn-action btn-action-back"
            :to="`/accounts`">
            <i class="fas fa-chevron-left" />
          </router-link>
          <div class="title-container">
            <div class="title">
              <div class="header-container">
                <div class="title-header">สร้างผู้ใช้ใหม่</div>
              </div>
            </div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="isServerError()">
                {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <button
              type="submit"
              :disabled="!isValid"
              @click.stop="createUser"
              class="btn btn-primary">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <UserRegistrationForm
          :user.sync="user"
          :saveUserStateError.sync="saveUserState.error"/>
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import Page from '@/layouts/Page.vue';

import { addUser } from './api';
import UserRegistrationForm from './UserRegistrationForm.vue';

export default {
  components: {
    Page,
    UserRegistrationForm,
  },
  data() {
    return {
      user: {
        name: null,
        email: null,
        password: null,
        confirmPassword: null,
        displayImage: null,
        roleId: 'editor',
      },
      errorStatus: null,
      saveUserState: {
        error: {
          name: null,
          email: null,
          password: null,
          confirmPassword: null,
          roleId: null,
        },
      },
    };
  },
  computed: {
    isValid() {
      return (this.user.name && this.user.email && this.user.password)
      && (_.every(this.saveUserState.error, _.isEmpty));
    },
  },
  methods: {
    isServerError() {
      return this.errorStatus;
    },
    async createUser() {
      try {
        delete this.user.confirmPassword;
        await addUser(this.user);
        this.errorStatus = null;
        this.$router.push('/accounts');
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveUserState.error = error.response.data;
      }
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500 || errorStatus === 404) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422 || errorStatus === 409) {
        return 'กรอกข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
